import { EException } from 'types/response-code/complaint';

export const complaintErrorMessageInfo: Record<EException, string> = {
  '100': 'Không tìm thấy khiếu nại',
  '101': 'Khiếu nại đã đóng',
  '102': 'Đã quá thời hạn bình luận',
  '-1': 'Vui lòng kiểm tra lại thông tin'
};
